import { Popover } from '@mui/material'
import SubmitButton from 'components/form/SubmitButton'
import styled, { css } from 'styled-components'

const greenAutoMapRangeInputStyles = css`
  appearance: none;
  -webkit-appearance: none;
  background: transparent;
  margin: 0;
  height: 16px;

  &::-webkit-slider-runnable-track {
    appearance: none;
    -webkit-appearance: none;
    height: 6px;
    border: 0;
    border-radius: 999px;
    background: linear-gradient(
      to right,
      #0bb163 0%,
      #0bb163 var(--slider-progress, 0%),
      rgba(255, 255, 255, 0.2) var(--slider-progress, 0%),
      rgba(255, 255, 255, 0.2) 100%
    );
  }

  &::-webkit-slider-thumb {
    appearance: none;
    -webkit-appearance: none;
    width: 12px;
    height: 12px;
    margin-top: -3px;
    border: 0;
    border-radius: 50%;
    background: #fff;
    box-shadow: none;
  }

  &::-moz-range-track {
    height: 6px;
    border: 0;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.2);
  }

  &::-moz-range-progress {
    height: 6px;
    border: 0;
    border-radius: 999px;
    background: #0bb163;
  }

  &::-moz-range-thumb {
    width: 12px;
    height: 12px;
    border: 0;
    border-radius: 50%;
    background: #fff;
    box-shadow: none;
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`

export const DarkBlurBackground = styled.div`
  border-radius: 12px;
  border-top: 0.5px solid rgba(255, 255, 255, 0.15);
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.15);
  background: rgba(20, 24, 26, 0.7);
  backdrop-filter: blur(5px);
  color: #fff;
  padding: 12px 16px;
`

export const SavePopoverOption = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
`

export const SavePopoverDescription = styled.p<{ $disabled?: boolean }>`
  margin: -2px 0 0 33px;
  color: ${(props) => (props.$disabled ? 'rgba(255, 255, 255, 0.5)' : 'rgba(255, 255, 255, 0.7)')};
  font-size: 12px;
  line-height: 1.4;
`

export const HeadingElementWrapper = styled.div`
  position: fixed;
  top: 24px;
  left: 24px;
  display: flex;
  align-items: stretch;
  gap: 6px;
  flex-direction: column;
`

export const LogoMenuToggle = styled.div`
  cursor: pointer;
  position: relative;
  width: 29px;
  height: 29px;

  & .logo,
  & .menu {
    position: absolute;
    left: 0;
    top: 0;
    transition: opacity 0.2s;
  }

  & .logo {
    opacity: 1;
  }

  & .menu {
    opacity: 0;
  }

  &:hover {
    & .logo {
      opacity: 0;
    }
    & .menu {
      opacity: 1;
    }
  }
`

export const MenuToggle = styled.div`
  width: 29px;
  height: 29px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background-color: rgba(255, 255, 255, 0.1);
`

export const MenuPopover = styled(DarkBlurBackground)`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  justify-content: space-between;
`

export const ToolbarStack = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`

export const ToolbarWrapper = styled.div`
  position: relative;
`

export const GreenToolActions = styled(DarkBlurBackground)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 4px;
  padding: 6px 8px;
`

export const GreenToolStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const GreenAutoMapToolbar = styled(DarkBlurBackground)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;

  @media (max-width: 820px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const GreenAutoMapToolbarSlider = styled.div`
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
`

export const GreenAutoMapToolbarSliderLabel = styled.span`
  color: #fff;
  font-size: 12px;
  font-weight: 500;
`

export const GreenAutoMapToolbarSliderInput = styled.input`
  width: 85px;
  flex: 0 0 85;
  ${greenAutoMapRangeInputStyles}
`

export const GreenAutoMapSlider = styled.input`
  width: 100%;
  ${greenAutoMapRangeInputStyles}
`

export const GreenAutoMapToolbarActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 6px;
`

export const GreenAutoMapToolbarToggle = styled.button<{ $active: boolean }>`
  border-radius: 8px;
  background: ${(props) => (props.$active ? 'rgba(255, 255, 255, 0.16)' : 'transparent')};
  color: #fff;
  cursor: pointer;
  height: 32px;
  width: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  transition: all 0.15s;

  &:hover {
    background: ${(props) => (props.$active ? 'rgba(255, 255, 255, 0.16)' : 'rgba(255, 255, 255, 0.08)')};
  }
`

export const GreenAutoMapToolbarStatus = styled.span`
  color: #0bb163;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
`

export const GreenAutoMapToolbarStepper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`

export const GreenAutoMapToolbarStepperButton = styled.button`
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  padding: 0;
  transition: background 0.15s;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.2);
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`

export const GreenAutoMapToolbarStepperValue = styled.span`
  color: #fff;
  font-size: 12px;
`

export const GreenAutoMapSecondaryButton = styled.button`
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #bbbbbd;
  font-size: 12px;
  font-weight: 400;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.15s;
  padding: 0 6px;
  min-height: 32px;
  white-space: nowrap;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`

export const GreenToolSecondaryButton = styled(GreenAutoMapSecondaryButton)`
  color: #fff;
  font-weight: 400;
`

export const GreenAutoMapPrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 0;
  border-radius: 8px;
  background: #0bb163;
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  display: flex;
  padding: 0 6px;
  min-height: 32px;
  box-shadow:
    0 10px 15px -3px rgba(11, 177, 99, 0.2),
    0 4px 6px -4px rgba(11, 177, 99, 0.2);
  transition: all 0.15s;
  white-space: nowrap;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }

  &:hover {
    background: #0d9656;
  }
`

export const GreenAutoMapPanel = styled(DarkBlurBackground)`
  position: fixed;
  top: 99px;
  left: 24px;
  z-index: 2;
  width: min(320px, calc(100vw - 32px));
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
`

export const GreenAutoMapPanelHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
`

export const GreenAutoMapPanelHeaderActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`

export const GreenAutoMapPanelCloseButton = styled.button`
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 1;
  transition: background 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
  }

  &:disabled {
    opacity: 0.45;
    cursor: default;
  }
`

export const GreenAutoMapPanelTitle = styled.span`
  color: #fff;
  font-size: 13px;
  font-weight: 600;
`

export const GreenAutoMapResetButton = styled.button`
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  padding: 5px 10px;

  &:disabled {
    opacity: 0.45;
    cursor: default;
  }
`

export const GreenAutoMapControl = styled.label`
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #fff;
`

export const GreenAutoMapControlHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
`

export const GreenAutoMapControlValue = styled.span`
  color: #d7f5d7;
  font-variant-numeric: tabular-nums;
  font-size: 11px;
`

export const GreenAutoMapPointsValue = styled.span`
  color: #fff;
  font-size: 11px;
  width: 14px;
`

export const GreenAutoMapControlRange = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #8a8a8e;
  font-size: 10px;
  font-variant-numeric: tabular-nums;
`

export const GreenAutoMapToggleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 2px;
`

export const GreenAutoMapToggleRow = styled.label`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  color: #fff;
`

export const GreenAutoMapToggleText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const GreenAutoMapToggleLabel = styled.span`
  color: #fff;
  font-size: 12px;
  font-weight: 500;
`

export const GreenAutoMapToggleDescription = styled.span`
  color: #8a8a8e;
  font-size: 10px;
  line-height: 1.35;
`

export const GreenAutoMapToggleInput = styled.input`
  width: 16px;
  height: 16px;
  margin: 1px 0 0;
  accent-color: #64d26b;
  flex: 0 0 auto;
`

export const GreenAutoMapTuningSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
`

export const GreenAutoMapTuningTitle = styled.span`
  color: #fff;
  font-size: 12px;
  font-weight: 600;
`

export const GreenAutoMapTuningDescription = styled.span`
  color: #8a8a8e;
  font-size: 10px;
  line-height: 1.35;
`

export const GreenAutoMapTuningActions = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 4px;
`

export const GreenAutoMapTuningStatus = styled.span<{ $tone?: 'info' | 'error' }>`
  font-size: 10px;
  line-height: 1.35;
  color: ${(props) => (props.$tone === 'error' ? '#ff8a8a' : '#8acf9b')};
`

export const HeadingElement = styled(DarkBlurBackground)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  min-width: 220px;
`

export const PlacesInput = styled.input`
  box-sizing: border-box;
  border: 1px solid transparent;
  border-radius: 6px;
  outline: none;
  font-size: 14px;
  background: transparent;
  color: #fff;
  &::placeholder {
    color: #8a8a8e;
  }
`

export const MapControlIcons = styled.div`
  position: fixed;
  left: 24px;
  bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  user-select: none;
`

export const ZoomControls = styled(DarkBlurBackground)`
  width: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px;
  border-radius: 999px;

  & span {
    width: 100%;
    aspect-ratio: 1;
    border-radius: 999px;
    color: #fff;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
`

export const RotateControls = styled(DarkBlurBackground)<{ $active: boolean }>`
  width: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px;
  border-radius: 999px;
  transition: all 0.15s;

  & span {
    width: 100%;
    aspect-ratio: 1;
    border-radius: 999px;
    color: #fff;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
`

export const TiltButton = styled.span<{ $active: boolean }>`
  & svg {
    transition: transform 0.2s;
    transform: ${(props) => (props.$active ? 'perspective(20px) rotate3d(1, 0, 0, 30deg) translateY(-2px)' : '0')};
  }
`

export const HoleSelectorsOverlay = styled.div`
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
`

export const HoleSelectorContainer = styled.div`
  position: relative;
`

export const ToolbarPlaceholder = styled.div`
  width: 25%;
  padding-left: 50px;
`

export const HoleSelectors = styled(DarkBlurBackground)`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  border-radius: 999px;
  align-items: center;
  padding: 4px;
`

export const HolePickerButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-width: 100px;
  border: 0;
  background: transparent;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
`

export const HolePickerDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
`

export const HoleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(9, 26px);
  gap: 6px;
  justify-content: center;
`

export const HoleOption = styled.button<{ $selected: boolean; $hasMarkers: boolean }>`
  border: 0;
  width: 26px;
  height: 26px;
  padding: 0;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  color: #fff;
  cursor: pointer;
  background: ${(props) => {
    if (props.$selected && props.$hasMarkers) {
      return '#055831'
    }
    if (props.$selected) {
      return '#000'
    }
    if (props.$hasMarkers) {
      return '#0bb163'
    }
    return 'rgba(255, 255, 255, 0.15)'
  }};

  &:hover {
    filter: brightness(1.08);
  }
`

export const ActionButtons = styled(DarkBlurBackground)`
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 1;
  display: flex;
  gap: 16px;
`

export const SaveButton = styled(SubmitButton)`
  display: flex;
  height: 30px;
  padding: 8px 12px;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  background: #0bb163;
  color: var(--Paper-Colors-White, #fff);
  font-weight: 500;
  font-size: 14px;
`

export const SaveButtonText = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`

export const SavePopover = styled(Popover)`
  & .MuiPaper-root {
    margin-top: 8px;
    border-radius: 8px;
    background-color: #1c1c1c;
  }
`

export const SavePopoverContent = styled.div`
  padding: 16px;
  width: 305px;
  color: #fff;
`

export const SavePopoverTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
`

export const IconDivider = styled.div`
  background-color: rgba(255, 255, 255, 0.25);
  height: 27px;
  width: 1px;
`

export const HorizontalIconDivider = styled.div`
  background-color: rgba(255, 255, 255, 0.25);
  height: 1px;
  width: 27px;
`

export const SliderBackground = styled.div`
  padding: 5px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  display: inline-flex;
  align-items: center;
  gap: 6px;
`
